import Redirect from '@bottlebooks/gatsby-theme-event/src/components/Redirect';
import React from 'react';

export default function TastingList({ data, ...rest }) {
  return <Redirect to="/favorites" />;
}
